import { Box }                                              from '@mui/material';
import { LocalizationProvider }                             from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs }                                     from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker }                                       from '@mui/x-date-pickers/DatePicker';
import { makeStyles }                                       from '@mui/styles';
import { ptBR }                                             from '@mui/x-date-pickers/locales';

const useStyles = makeStyles({root: {"& .MuiOutlinedInput-input": { fontFamily: 'Saira !important', fontSize: '1rem', padding: '7px' }}});

const Datepicker = ({
    
    datesList,
    handleError,

    views,
    format,

    selectedValue,
    onChange,

    onYearChange,
    onMonthChange,

    ...disableProps

}) => {
    
    const classes = useStyles()

    return (

        <div className="flex gap-[10px] flex-row text-[0.8rem] text-nowrap">
                    
            {/* Filtro de data */}
            <Box sx={{ width: 200}}>
                
                <LocalizationProvider 
                    
                    dateAdapter={AdapterDayjs}
                    adapterLocale="pt-br"
                    localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
                    
                >

                <DatePicker
                            
                    className={classes.root}
             
                    value={selectedValue}
                    
                    onChange={(newValue) => onChange(newValue)}
                    onError={(reason, value) => handleError(reason, value)}

                    format={format}                    
                    views={views} 

                    onYearChange={(newValue) => onYearChange(newValue)}
                    
                    {...disableProps}
        
                />

                </LocalizationProvider>

            </Box>


        </div>
    )
}
            // <span>datesList : {JSON.stringify(datesList)}</span>
            // <span>value : {JSON.stringify(selectedValue)}</span>
export default Datepicker
